<script>
import Layout from '@layouts/default'
import VehicleSearch from '@components/vehicle-search'

export default {
  page: {
    title: 'Data Backed by Experian | AutoCheck.com',
    meta: [
      {
        name: 'description',
        content: 'AutoCheck Vehicle History Reports - Data Backed by Experian',
      },
    ],
    link: [
      {
        rel: 'canonical',
        href: 'https://www.autocheck.com/vehiclehistory/backed-by-experian',
      },
    ],
  },
  components: { Layout, VehicleSearch },
}
</script>

<template>
  <Layout>
    <div class="row">
      <div class="col-12 mt-4 mb-4">
        <h1>Data Backed by Experian</h1>
        <hr />
      </div>
      <div class="col-12">
        <p
          >AutoCheck® has industrial-strength data backed by
          <a target="_blank" href="http://www.experian.com">Experian</a>, the
          global market leader in information services. This means we offer
          customers just like you the same exceptional data reliability and use
          the same expert business rules that industries around the world trust
          to get the insights they need to make the best decisions.</p
        >
        <p
          >When you purchase an AutoCheck® vehicle history report from Experian,
          you can rest easy knowing that you are using the report that
          automotive industry experts rely on daily to get the information they
          need to buy and sell the most trusted vehicles.&nbsp;</p
        >
        <h3 class="titleBlue"
          >Make a better buying decision with industrial strength data from
          Experian Automotive</h3
        >

        <div class="content"
          ><div class="content-page-inner-box"
            ><h2
              >Make a better buying decision with industrial strength data from
              Experian Automotive</h2
            >
            <p
              ><img
                src="https://www.autocheck.com/communications/data-source-ac-logo-graphic-610x611.png"
                alt="AutoCheck Data Source"
                width="610"
                height="611"
                usemap="#Map"
                style="margin: 25px 0 25px 0; max-width: 100%; height: auto;"
                vspace="15"
                hspace="15"
                border="0"
                align="left"
              />
              <map name="Map">
                <area
                  v-scroll-to="'#dmv'"
                  shape="rect"
                  coords="283,7,603,53"
                  href="#"
                  alt="dmv"
                />
                <area
                  v-scroll-to="'#auctions'"
                  shape="rect"
                  coords="285,63,610,107"
                  href="#"
                  alt="auctions"
                />
                <area
                  v-scroll-to="'#collision'"
                  shape="rect"
                  coords="284,119,605,167"
                  href="#"
                  alt="collision"
                />
                <area
                  v-scroll-to="'#service'"
                  shape="rect"
                  coords="284,177,606,218"
                  href="#"
                  alt="service"
                />
                <area
                  v-scroll-to="'#insurance'"
                  shape="rect"
                  coords="284,229,601,274"
                  href="#"
                  alt="insurance"
                />
                <area
                  v-scroll-to="'#manufacturers'"
                  shape="rect"
                  coords="283,284,608,331"
                  href="#"
                  alt="manufacturers"
                />
                <area
                  v-scroll-to="'#law'"
                  shape="rect"
                  coords="284,338,605,385"
                  href="#"
                  alt="law"
                />
                <area
                  v-scroll-to="'#dealership'"
                  shape="rect"
                  coords="284,395,608,440"
                  href="#"
                  alt="dealership"
                />
                <area
                  v-scroll-to="'#import'"
                  shape="rect"
                  coords="285,450,603,495"
                  href="#"
                  alt="import"
                />
                <area
                  v-scroll-to="'#rental'"
                  shape="rect"
                  coords="285,507,606,549"
                  href="#"
                  alt="rental"
                />
                <area
                  v-scroll-to="'#inspection'"
                  shape="rect"
                  coords="282,560,605,603"
                  href="#"
                  alt="inspection"
                />
              </map>
            </p>
            <div class="content-page-inner-box"
              ><div class="sectionContent"
                ><div class="gradientAlignMiddle"
                  ><table
                    :class="$style.table"
                    cellspacing="0"
                    cellpadding="0"
                    border="0"
                    style="width: 100%;"
                  >
                    <tbody
                      style="font-weight:normal; font-family:Roboto, sans-serif; font-size:14px; color:#2e2e2e;"
                    >
                      <tr>
                        <td
                          style="font-weight:normal; font-family:Roboto, sans-serif; font-size:22px; color:#2e2e2e;"
                          colspan="2"
                          ><strong>AutoCheck’s Unique Data Sources</strong>
                          <br />
                          <font
                            style="font-weight:normal; font-family:Roboto, sans-serif; font-size:14px; line-height:28px; color:#2e2e2e;"
                            colspan="2"
                            >Make a better used car buying decision with
                            industrial strength data from Experian
                            Automotive.</font
                          ></td
                        >
                      </tr>
                      <tr>
                        <td width="193" valign="top" height="204"
                          ><div align="left" valign="top"
                            ><font
                              style="font-weight:normal; font-family:Roboto, sans-serif; font-size:16px; color:#2e2e2e; "
                              ><strong
                                >State Department of Motor Vehicles
                                (DMV’s)</strong
                              ></font
                            ></div
                          ></td
                        >
                        <td width="417" class="imageCell"
                          ><div align="left"
                            ><p
                              ><font
                                style="font-weight:normal; font-family:Roboto, sans-serif; font-size:14px; color:#000;"
                                ><font
                                  style="font-weight:normal; font-family:Roboto, sans-serif; font-size:16px; color:#2e2e2e; "
                                  ><strong><a id="dmv"></a></strong></font
                                >Identify important issues like title problems,
                                accidents, or potential fraud that may help you
                                uncover problems.</font
                              ></p
                            >
                            <font
                              style="font-weight:normal; font-family:Roboto, sans-serif; font-size:12px; color:#000;"
                            >
                              <ul>
                                <li
                                  >Branded titles, including salvage/junk,
                                  flood, hail, storm, fire damage and more</li
                                >
                                <li>Manufacturer buybacks or lemon titles</li>
                                <li>Odometer rollback or not actual miles</li>
                                <li
                                  >City and state of previous registration,
                                  number of owners</li
                                >
                                <li
                                  >Accidents and damage reports, stolen
                                  vehicles</li
                                >
                                <li>Rental , taxi, lease, or government use</li>
                                <li
                                  >Lien information, ownership transfers<br /><font
                                    style="font-weight:normal; font-family:Roboto, sans-serif; font-size:14px; color:#000;"
                                    ><font
                                      style="font-weight:normal; font-family:Roboto, sans-serif; font-size:16px; color:#2e2e2e; "
                                      ><strong
                                        ><a
                                          name="auctions"
                                        ></a></strong></font></font
                                ></li>
                              </ul> </font></div
                        ></td>
                      </tr>
                      <tr>
                        <td valign="top"
                          ><div align="left" valign="top"
                            ><font
                              style="font-weight:normal; font-family:Roboto, sans-serif; font-size:16px; color:#2e2e2e; "
                              ><strong>Auto auctions</strong></font
                            ></div
                          ></td
                        >
                        <td class="imageCell"
                          ><div align="left"
                            ><p
                              ><font
                                style="font-weight:normal; font-family:Roboto, sans-serif; font-size:14px; color:#000;"
                                >Find a reliable vehicle that has been through
                                the auction inspection process.</font
                              ></p
                            >
                            <font
                              style="font-weight:normal; font-family:Roboto, sans-serif; font-size:12px; color:#000;"
                            >
                              <ul>
                                <li>Low odometer readings</li>
                                <li>Structural or frame damage</li>
                              </ul>
                            </font></div
                          ></td
                        >
                      </tr>
                      <tr>
                        <td valign="top"
                          ><div align="left" valign="top"
                            ><font
                              style="font-weight:normal; font-family:Roboto, sans-serif; font-size:16px; color:#2e2e2e; "
                              ><strong>Salvage auctions</strong></font
                            ></div
                          ></td
                        >
                        <td class="imageCell"
                          ><div align="left"
                            ><p
                              ><font
                                style="font-weight:normal; font-family:Roboto, sans-serif; font-size:14px; color:#000;"
                                >Discover if the car is salvaged, but was not
                                titled as salvage by the DMV.</font
                              ></p
                            >
                            <font
                              style="font-weight:normal; font-family:Roboto, sans-serif; font-size:12px; color:#000;"
                            >
                              <ul
                                ><li>Salvaged</li
                                ><li>Junked or Recycled</li></ul
                              ><p
                                ><font
                                  style="font-weight:normal; font-family:Roboto, sans-serif; font-size:16px; color:#2e2e2e; "
                                  ><strong
                                    ><a
                                      name="collision"
                                    ></a></strong></font></p></font></div
                        ></td>
                      </tr>
                      <tr>
                        <td valign="top"
                          ><div align="left" valign="top"
                            ><font
                              style="font-weight:normal; font-family:Roboto, sans-serif; font-size:16px; color:#2e2e2e; "
                              ><strong>Collision repair shops</strong></font
                            ></div
                          ></td
                        >
                        <td valign="top" class="imageCell"
                          ><div align="left"
                            ><p
                              ><font
                                style="font-weight:normal; font-family:Roboto, sans-serif; font-size:14px; color:#000;"
                                >Understand if a vehicle was in one or more
                                accidents.</font
                              ></p
                            >
                            <font
                              style="font-weight:normal; font-family:Roboto, sans-serif; font-size:12px; color:#000;"
                            >
                              <ul>
                                <li>Collision repair history</li>
                                <li
                                  >Structural or frame damage<br /><font
                                    style="font-weight:normal; font-family:Roboto, sans-serif; font-size:16px; color:#2e2e2e; "
                                    ><strong
                                      ><a name="service"></a></strong></font
                                ></li>
                              </ul> </font></div
                        ></td>
                      </tr>
                      <tr>
                        <td valign="top"
                          ><div align="left" valign="top"
                            ><font
                              style="font-weight:normal; font-family:Roboto, sans-serif; font-size:16px; color:#2e2e2e; "
                              ><strong
                                >Service and maintenance facilities</strong
                              ></font
                            ></div
                          ></td
                        >
                        <td valign="top" class="imageCell"
                          ><div align="left"
                            ><p
                              ><font
                                style="font-weight:normal; font-family:Roboto, sans-serif; font-size:14px; color:#000;"
                                >Know when a vehicle was serviced and what was
                                serviced or repaired.</font
                              ></p
                            >
                            <font
                              style="font-weight:normal; font-family:Roboto, sans-serif; font-size:12px; color:#000;"
                            >
                              <ul>
                                <li
                                  >Service, repair and maintenance performed</li
                                >
                                <li>Odometer readings</li>
                                <li
                                  >Service, repair and maintenance dates and
                                  locations<br /><font
                                    style="font-weight:normal; font-family:Roboto, sans-serif; font-size:16px; color:#2e2e2e; "
                                    ><strong
                                      ><a name="insurance"></a></strong></font
                                ></li>
                              </ul> </font></div
                        ></td>
                      </tr>
                      <tr>
                        <td valign="top"
                          ><div align="left" valign="top"
                            ><font
                              style="font-weight:normal; font-family:Roboto, sans-serif; font-size:16px; color:#2e2e2e; "
                              ><strong>Insurance companies</strong></font
                            ></div
                          ></td
                        >
                        <td valign="top" class="imageCell"
                          ><div align="left"
                            ><p
                              ><font
                                style="font-weight:normal; font-family:Roboto, sans-serif; font-size:14px; color:#000;"
                                >Identify hidden problems not reported to the
                                state DMV.</font
                              ></p
                            >
                            <font
                              style="font-weight:normal; font-family:Roboto, sans-serif; font-size:12px; color:#000;"
                            >
                              <ul>
                                <li> Total loss and reason for loss</li>
                                <li
                                  >Stolen vehicles<br /><font
                                    style="font-weight:normal; font-family:Roboto, sans-serif; font-size:16px; color:#2e2e2e; "
                                    ><strong
                                      ><a
                                        name="manufacturers"
                                      ></a></strong></font
                                ></li>
                              </ul> </font></div
                        ></td>
                      </tr>
                      <tr>
                        <td valign="top"
                          ><div align="left" valign="top"
                            ><font
                              style="font-weight:normal; font-family:Roboto, sans-serif; font-size:16px; color:#2e2e2e; "
                              ><strong>Manufacturers</strong></font
                            ></div
                          ></td
                        >
                        <td valign="top" class="imageCell"
                          ><div align="left"
                            ><p
                              ><font
                                style="font-weight:normal; font-family:Roboto, sans-serif; font-size:14px; color:#000;"
                                >Get insights right from the OEM.</font
                              ></p
                            >
                            <font
                              style="font-weight:normal; font-family:Roboto, sans-serif; font-size:12px; color:#000;"
                            >
                              <ul>
                                <li>Open recalls</li>
                                <li>Certified pre-owned vehicles</li>
                                <li
                                  >Courtesy buybacks<br /><font
                                    style="font-weight:normal; font-family:Roboto, sans-serif; font-size:16px; color:#2e2e2e; "
                                    ><strong><a name="law"></a></strong></font
                                ></li>
                              </ul> </font></div
                        ></td>
                      </tr>
                      <tr>
                        <td valign="top"
                          ><div align="left" valign="top"
                            ><font
                              style="font-weight:normal; font-family:Roboto, sans-serif; font-size:16px; color:#2e2e2e; "
                              ><strong>Law enforcement agencies</strong></font
                            ></div
                          ></td
                        >
                        <td valign="top" class="imageCell"
                          ><div align="left"
                            ><p
                              ><font
                                style="font-weight:normal; font-family:Roboto, sans-serif; font-size:14px; color:#000;"
                                >Identify significant events affecting the
                                vehicle’s value.</font
                              ></p
                            >
                            <font
                              style="font-weight:normal; font-family:Roboto, sans-serif; font-size:12px; color:#000;"
                            >
                              <ul>
                                <li
                                  >Stolen vehicle records and theft recovery</li
                                >
                                <li
                                  >Accident reports<br /><font
                                    style="font-weight:normal; font-family:Roboto, sans-serif; font-size:16px; color:#2e2e2e; "
                                    ><strong
                                      ><a name="dealership"></a></strong></font
                                ></li>
                              </ul> </font></div
                        ></td>
                      </tr>
                      <tr>
                        <td valign="top"
                          ><div align="left" valign="top"
                            ><font
                              style="font-weight:normal; font-family:Roboto, sans-serif; font-size:16px; color:#2e2e2e; "
                              ><strong
                                >Car dealerships and extended warranty
                                companies</strong
                              ></font
                            ></div
                          ></td
                        >
                        <td valign="top" class="imageCell"
                          ><div align="left"
                            ><p
                              ><font
                                style="font-weight:normal; font-family:Roboto, sans-serif; font-size:14px; color:#000;"
                                >Know when the vehicle was offered for
                                sale.</font
                              ></p
                            >
                            <font
                              style="font-weight:normal; font-family:Roboto, sans-serif; font-size:12px; color:#000;"
                            >
                              <ul>
                                <li>Vehicle's geographic location</li>
                                <li>Odometer readings</li>
                                <li
                                  >Repair and maintenance history<br /><font
                                    style="font-weight:normal; font-family:Roboto, sans-serif; font-size:16px; color:#2e2e2e; "
                                    ><strong
                                      ><a name="import"></a></strong></font
                                ></li>
                              </ul> </font></div
                        ></td>
                      </tr>
                      <tr>
                        <td valign="top"
                          ><div align="left" valign="top"
                            ><font
                              style="font-weight:normal; font-family:Roboto, sans-serif; font-size:16px; color:#2e2e2e; "
                              ><strong>Import/export companies</strong></font
                            ></div
                          ></td
                        >
                        <td valign="top" class="imageCell"
                          ><div align="left"
                            ><p
                              ><font
                                style="font-weight:normal; font-family:Roboto, sans-serif; font-size:14px; color:#000;"
                                >Get a view into a car’s movements.</font
                              ></p
                            >
                            <font
                              style="font-weight:normal; font-family:Roboto, sans-serif; font-size:12px; color:#000;"
                            >
                              <ul>
                                <li
                                  >Vehicle transfers and locations<br /><font
                                    style="font-weight:normal; font-family:Roboto, sans-serif; font-size:16px; color:#2e2e2e; "
                                    ><strong
                                      ><a name="rental"></a></strong></font
                                ></li>
                              </ul> </font></div
                        ></td>
                      </tr>
                      <tr>
                        <td valign="top"
                          ><div align="left" valign="top"
                            ><font
                              style="font-weight:normal; font-family:Roboto, sans-serif; font-size:16px; color:#2e2e2e; "
                              ><strong>Rental and fleet companies</strong></font
                            ></div
                          ></td
                        >
                        <td valign="top" class="imageCell"
                          ><div align="left"
                            ><p
                              ><font
                                style="font-weight:normal; font-family:Roboto, sans-serif; font-size:14px; color:#000;"
                                >Understand if a vehicle was used by a rental
                                company or as a fleet vehicle.</font
                              ></p
                            >
                            <font
                              style="font-weight:normal; font-family:Roboto, sans-serif; font-size:12px; color:#000;"
                            >
                              <ul>
                                <li>Total loss and damage history</li>
                                <li
                                  >Maintenance/service history<br /><font
                                    style="font-weight:normal; font-family:Roboto, sans-serif; font-size:16px; color:#2e2e2e; "
                                    ><strong
                                      ><a name="inspection"></a></strong></font
                                ></li>
                              </ul> </font></div
                        ></td>
                      </tr>
                      <tr>
                        <td valign="top"
                          ><div align="left" valign="top"
                            ><font
                              style="font-weight:normal; font-family:Roboto, sans-serif; font-size:16px; color:#2e2e2e; "
                              ><strong
                                >Vehicle inspection and state inspection
                                stations</strong
                              ></font
                            ></div
                          ></td
                        >
                        <td valign="top" class="imageCell"
                          ><div align="left"
                            ><p
                              ><font
                                style="font-weight:normal; font-family:Roboto, sans-serif; font-size:14px; color:#000;"
                                >See if the vehicle passed emissions and safety
                                testing.</font
                              ></p
                            >
                            <font
                              style="font-weight:normal; font-family:Roboto, sans-serif; font-size:12px; color:#000;"
                            >
                              <ul>
                                <li>Odometer readings</li>
                                <li>Location of inspection site</li>
                                <li>Emissions records</li>
                                <li>Safety inspection factors</li>
                              </ul>
                            </font></div
                          ></td
                        >
                      </tr>
                    </tbody>
                  </table></div
                >
                <p>&nbsp;</p></div
              ></div
            ></div
          ></div
        >
        <VehicleSearch />
      </div>
    </div>
  </Layout>
</template>

<style lang="scss" module>
@import '@design';

.table {
  border: #949494 1px solid;
  td {
    padding: 10px;
    border: #949494 1px solid;
  }
}
</style>
